module.exports = __webpack_public_path__ + "static/6-63f4d601cac95070eb7c5a6fefebaeef.jpg";